<template>
	<div class="kaibo">
		<div style="display: flex;align-items: center;">
			<div style="color: #333;font-size: 14px;width:100px;text-align: right;">微信号：</div>
			<el-input :disabled="(form.status=='' || form.status==3)?false:true" v-model="form.weixin" placeholder="请输入微信号" style="width: 300px;"></el-input>
		</div>
		<div style="display: flex;margin-top: 20px;">
			<div style="color: #333;font-size: 14px;width:100px;text-align: right;">个人简介：</div>
			<el-input :maxlength="100" :disabled="(form.status=='' || form.status==3)?false:true" v-model="form.remarks" type="textarea" placeholder="请输入个人简介" :rows="4"  style="width: 300px;"></el-input>
		</div>
		<div style="color: #333;font-size: 12px;margin-top: 10px;padding-left: 248px;">
			还可以输入{{100-form.remarks.length}}/100个字
		</div>
		<div style="display: flex;margin-top: 20px;">
			<div style="color: #333;font-size: 14px;width:100px;text-align: right;">状<span style="opacity: 0;">备</span>态：</div>
			<span style="font-size: 14px;">
			   <span v-if="form.status==''" style="color:red;">待提交</span>
			   <span v-if="form.status==1" style="color:red;">待审核</span>
			   <span v-if="form.status==2">已通过</span>
			   <span v-if="form.status==3">已拒绝</span>
			</span>
		</div>
		<div style="display: flex;margin-top: 40px;margin-left: 52px;" v-if="form.status=='' || form.status==3">
			<el-button type="primary" @click="user_kaobo_save">
				{{form.status==''?'提交':form.status==3?'重新提交':''}}
			</el-button>
		</div>
	</div>
</template>

<script>
	import { user_look_kaibo,user_kaobo_save } from "@/api/user"
	export default {
		data(){
			return{
				form:{
					weixin:'',
					remarks:'',
					status:''
				},
			}
		},
		watch:{
			
		},
		mounted(){
			this.user_look_kaibo();
		},
		methods:{
			user_kaobo_save(){
				if(!this.form.weixin || !this.form.remarks){
					this.$message.error("微信号或备注不能为空");
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '提交中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				user_kaobo_save({
					weixin:this.form.weixin,
					remarks:this.form.remarks
				}).then(()=>{
					loading.close();
					this.$message.success("成功");
					this.user_look_kaibo();
				}).catch(()=>{
					loading.close();
				})
			},
			user_look_kaibo(){
				user_look_kaibo({}).then(res=>{
					console.log("开博信息",res.data);
					if(res.data){
						this.form = {
							weixin:res.data.weixin,
							remarks:res.data.remarks,
							status:res.data.status
						}
					}
				}).catch(()=>{
					
				})
			},
		},
	}
</script>

<style lang="scss">
	.kaibo{
		margin-top: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/new/kaibo.vue